import { createContext, useContext } from 'react';
import { defaultTab, tabSectionMap } from 'modules/iterableGoals/constants';
import { TabContextState } from 'modules/iterableGoals/types';
import noop from 'utils/noop';

export const initalTabContextState = {
  selectedTab: defaultTab,
  setSelectedTab: noop,
  sections: tabSectionMap[defaultTab],
  setErrorState: noop,
  setLoadingState: noop,
  loadAllSections: noop,
};

export const TabContext = createContext<TabContextState>(initalTabContextState);

export const useTabContext = () => useContext(TabContext);
